import type {
  StoreAvailableProductsResponse,
  StoreCamera,
  StoreCameraViewSession,
  StoreDashboardStatsResponse,
  StoreProcessTaskResponse,
  StoreProductLotsResponse,
  StorePlanningWeekResponse,
  StoreStockResponse,
  StoreTodayActionsResponse,
  StoreLiveCaResponse,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

// back-office : tâches « process » déjà planifiées d'une boutique (guard `admin`)
export const fetchStoreProcessTasks = async (
  storeId: number,
): Promise<StoreProcessTaskResponse[]> => {
  const response = await gozokiApiWithAuth.get<StoreProcessTaskResponse[]>('/store-process-tasks', {
    params: { storeId },
  })
  return response.data
}

// store-app : CA temps réel de la boutique connectée (guard `store`)
export const fetchStoreLiveCa = async (): Promise<StoreLiveCaResponse> => {
  const response = await gozokiApiWithAuth.get<StoreLiveCaResponse>('/store/live-ca')
  return response.data
}

// store-app : scores opérationnels + CA chart 7 jours de la boutique connectée
export const fetchStoreDashboardStats = async (): Promise<StoreDashboardStatsResponse> => {
  const response =
    await gozokiApiWithAuth.get<StoreDashboardStatsResponse>('/store/dashboard-stats')
  return response.data
}

// store-app : stock restant de la boutique connectée (total UVC + répartition par catégorie)
export const fetchStoreOwnStock = async (): Promise<StoreStockResponse> => {
  const response = await gozokiApiWithAuth.get<StoreStockResponse>('/store/stock')
  return response.data
}

// store-app : produits en rayon de la boutique connectée, les plus critiques d'abord.
// `categoryId` omis = toutes catégories (pastille « Global » de la modale flux supply).
export const fetchStoreAvailableProducts = async (
  categoryId?: number,
): Promise<StoreAvailableProductsResponse> => {
  const response = await gozokiApiWithAuth.get<StoreAvailableProductsResponse>(
    '/store/available-products',
    { params: categoryId === undefined ? undefined : { categoryId } },
  )
  return response.data
}

// store-app : détail par lot d'un produit en rayon de la boutique connectée
export const fetchStoreProductLots = async (
  reference: string,
): Promise<StoreProductLotsResponse> => {
  const response = await gozokiApiWithAuth.get<StoreProductLotsResponse>('/store/product-lots', {
    params: { reference },
  })
  return response.data
}

// store-app : caméras de la boutique connectée (URLs go2rtc)
export const fetchStoreOwnCameras = async (): Promise<StoreCamera[]> => {
  const response = await gozokiApiWithAuth.get<StoreCamera[]>('/store/cameras')
  return response.data
}

// store-app : session viewer go2rtc (token à ajouter en query aux flux)
export const fetchStoreCameraViewSession = async (): Promise<StoreCameraViewSession> => {
  const response = await gozokiApiWithAuth.get<StoreCameraViewSession>('/store/camera-view-session')
  return response.data
}

// `weekStart` = n'importe quelle date de la semaine visée (le backend la recale sur son lundi) ;
// omis, l'endpoint rend la semaine en cours.
export const fetchStorePlanningWeek = async (
  weekStart?: string,
): Promise<StorePlanningWeekResponse> => {
  const response = await gozokiApiWithAuth.get<StorePlanningWeekResponse>('/store/planning-week', {
    params: weekStart ? { weekStart } : undefined,
  })
  return response.data
}

export const fetchStoreTodayActions = async (): Promise<StoreTodayActionsResponse> => {
  const response = await gozokiApiWithAuth.get<StoreTodayActionsResponse>('/store/today-actions')
  return response.data
}
